export default "__VITE_ASSET__bad52d67__"